import React from 'react';
import { Stack } from '@mui/material';
import Select from 'components/select';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/myidm/store';
import ProvisioningStyles from 'pages/provisioning/vm/style';
import { endPoints } from 'api/endpoints';
import axios from 'api/request';
import { useMutation } from 'react-query';

const DomainType = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [options, setOptions] = React.useState([]);
    const domainTypesApi = useMutation(() => axios.get(endPoints.myIdm.domainTypes));
    const currentValue = order?.domainType;

    const setDomainType = (domainType) => {
        setOrder({
            ...order,
            domainType,
            adGroup: null,
            multipleAdGroups: (order?.multipleAdGroups || [])?.map(() => ({ adGroup: null, adGroupOwner: null, members: [] })),
        });
    };

    const handleOnSelectChange = (selected) => {
        setDomainType(selected.value);
    };

    const resetOptions = () => {
        setOptions([]);
    };

    React.useEffect(() => {
        if (domainTypesApi?.isSuccess) {
            setOptions(
                (domainTypesApi?.data?.data || [])
                    // ?.filter((domainType) => domainType !== 'cwwpvt')
                    ?.map((domainType) => ({
                        label: domainType,
                        value: domainType,
                    }))
            );
        }
    }, [domainTypesApi?.isSuccess]);

    React.useEffect(() => {
        resetOptions();
        domainTypesApi.mutate();
    }, []);

    React.useEffect(() => {
        if (!currentValue && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [currentValue, order?.isTouched]);

    return (
        <Stack direction="row" spacing={1} sx={ProvisioningStyles.stack}>
            <Select
                sx={{ marginTop: 0 }}
                key="domain-type"
                label="Domain Type *"
                value={options.find((option) => option.value === currentValue) || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                isRequired={isTouched}
                disabled={domainTypesApi.isLoading}
                isLoading={domainTypesApi.isLoading}
                isOptionEqualToValue={(option, selectedValue) => option.value === selectedValue.value}
            />
        </Stack>
    );
};

export default DomainType;
